import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Milestone from '../../entities/milestone';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteMilestone(): boolean {
return true;
}
export function collectMilestoneDeleteImpact(milestone: Milestone, context: DeleteImpactContext): void {
const key = 'milestone:' + milestone.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
}
export function deleteImpactMilestone(milestone: Milestone): DeleteImpact {
const context = deleteImpactContext();
collectMilestoneDeleteImpact(milestone, context);
return deleteImpactCounts(context);
}
export function deleteMilestone(milestone: Milestone, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteMilestone()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectMilestoneDeleteImpact(milestone, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || milestone.id};
}
const key = 'milestone:' + milestone.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));

const deleted = milestone.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.MilestoneActions.removeMilestoneQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}
